import { Component, OnInit } from '@angular/core';
import {
  GoogleAnalyticsService,
  MetadataService,
  ProductService,
  AuthService,
  AppState,
  AppWrapperComponent,
  SimpleRoute,
  NavbarConfigService,
  RouterEventsService
} from 'gung-standard';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'cult-wrapper',
    templateUrl: './cult-wrapper.component.html',
    styleUrls: ['./cult-wrapper.component.scss'],
    standalone: false
})
export class CultWrapperComponent extends AppWrapperComponent {
  showFastSearch: Observable<boolean> = new Observable<boolean>();

  

  protected getSalesMenu(): SimpleRoute[] {
    return [
      // {
      //   route: '/open-orders',
      //   heading: 'OPEN_ORDERS'
      // },
      {
        route: '/customers',
        heading: 'MY_CUSTOMERS'
      },
      {
        route: '/invoices',
        heading: 'INVOICES'
      },
      {
        route: '/products',
        heading: 'SHOP_BY_PRODUCT_LIST'
      }
    ];
  }

  protected getCustomerMenu(customerId: string): SimpleRoute[] {
    return [
      {
        route: `${'/customers/' + customerId}`,
        heading: 'MY_PAGES'
      },
      {
        route: '/orders',
        heading: 'PREVIOUS_ORDERS'
      },
      // {
      //   route: '/most-purchased',
      //   heading: 'MOST_PURCHASED'
      // },
      {
        route: '/products',
        heading: 'SHOP_BY_PRODUCT_LIST'
      }
    ];
  }
}
